import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal } from "./Reveal";
import { IMAGES } from "../data/products";
import { useLang } from "../i18n";

export const AttarStory = () => {
    const { t } = useLang();
    const STORIES = [
        { n: "01", title: t("attar.c1t"), text: t("attar.c1x") },
        { n: "02", title: t("attar.c2t"), text: t("attar.c2x") },
        { n: "03", title: t("attar.c3t"), text: t("attar.c3x") },
    ];
    const imgRef = useRef(null);
    const { scrollYProgress } = useScroll({ target: imgRef, offset: ["start end", "end start"] });
    const y = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);

    return (
        <section id="attar-story" className="bg-cream py-28 sm:py-40 px-6 sm:px-10" data-testid="attar-story-section">
            <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-14 lg:gap-24 items-center">
                <div className="relative">
                    <Reveal>
                        <div ref={imgRef} className="relative overflow-hidden border border-gold/30 aspect-[3/4]">
                            <motion.img
                                style={{ y, scale: 1.15 }}
                                src={IMAGES.arabianScenery}
                                alt="The golden heritage of Arabia — the world inside every Al Zahra attar"
                                className="w-full h-full object-cover"
                                data-testid="attar-story-artwork"
                            />
                        </div>
                    </Reveal>
                    <Reveal delay={0.15}>
                        <img
                            src={IMAGES.logo}
                            alt="Al Zahra Perfumery emblem"
                            className="absolute -bottom-10 -right-4 sm:-right-8 w-24 sm:w-28 bg-ivory border border-gold/30 p-3 mix-blend-multiply"
                            data-testid="attar-story-logo"
                        />
                    </Reveal>
                </div>

                <div>
                    <Reveal>
                        <p className="text-xs tracking-[0.3em] uppercase text-golddark mb-6">{t("attar.overline")}</p>
                        <h2 className="font-serif text-4xl sm:text-5xl tracking-tight leading-tight text-charcoal mb-6" data-testid="attar-story-heading">
                            {t("attar.heading")}
                        </h2>
                        <p className="text-smoke text-base leading-relaxed mb-14 max-w-lg">{t("attar.intro")}</p>
                    </Reveal>
                    <div className="space-y-0 divide-y divide-gold/20 border-t border-b border-gold/25">
                        {STORIES.map((s, i) => (
                            <Reveal key={s.n} delay={i * 0.12}>
                                <div className="grid grid-cols-[64px_1fr] gap-6 py-8" data-testid={`attar-story-chapter-${s.n}`}>
                                    <span className="font-serif text-3xl text-gold/60 pt-1">{s.n}</span>
                                    <div>
                                        <h3 className="font-serif text-2xl tracking-tight text-charcoal mb-3">{s.title}</h3>
                                        <p className="text-sm text-smoke leading-relaxed">{s.text}</p>
                                    </div>
                                </div>
                            </Reveal>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};
